export default "<p>\n  pin-board works!\n</p>\n"